import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { dateFormatPipe } from './date-formatter.pipe';
import { phoneFormatPipe } from './phone-formatter.pipe';
import { timeDifferencePipe } from './time-difference-formatter.pipe';
import { contactViewPipe } from './phone-view.pipe';
import { cardNumberFormatPipe } from './card-number-formatter.pipe';
import { SafeUrlPipe } from './safe-url.pipe';


@NgModule({
    imports: [],
    declarations: [
        dateFormatPipe,
        phoneFormatPipe,
        timeDifferencePipe,
        contactViewPipe,
        cardNumberFormatPipe,
        SafeUrlPipe
    ],
    providers: [],
    exports: [
        dateFormatPipe,
        phoneFormatPipe,
        timeDifferencePipe,
        contactViewPipe,
        cardNumberFormatPipe,
        SafeUrlPipe
    ]
})

export class PipeModule { }